import { useTranslation } from 'react-i18next'
import { useGenerationFormStore } from '../store'
import { useSubmitGeneration } from '../hooks'
import { IconSpinner } from '@/app/components/icons'

export function GenerateButton() {
  const { t } = useTranslation()
  const checkpoint = useGenerationFormStore((s) => s.checkpoint)
  const positivePrompt = useGenerationFormStore((s) => s.positivePrompt)
  const isGenerating = useGenerationFormStore((s) => s.isGenerating)
  const setIsGenerating = useGenerationFormStore((s) => s.setIsGenerating)
  const setActiveGenerationId = useGenerationFormStore((s) => s.setActiveGenerationId)
  const toRequest = useGenerationFormStore((s) => s.toRequest)

  const submitMutation = useSubmitGeneration()

  const canSubmit = checkpoint.length > 0
    && positivePrompt.trim().length > 0
    && !isGenerating
    && !submitMutation.isPending

  const handleSubmit = () => {
    if (!canSubmit) return

    const request = toRequest()
    submitMutation.mutate(request, {
      onSuccess: (data) => {
        setIsGenerating(true)
        setActiveGenerationId(data.generation_id)
      },
    })
  }

  const isLoading = submitMutation.isPending || isGenerating

  return (
    <button
      type="button"
      onClick={handleSubmit}
      disabled={!canSubmit}
      className="relative w-full overflow-hidden rounded-xl px-4 py-3.5 text-base font-semibold transition-all duration-200 disabled:opacity-50 active:scale-[0.98] text-tg-button-text"
      style={{
        background: canSubmit
          ? 'linear-gradient(135deg, var(--tg-theme-button-color), color-mix(in srgb, var(--tg-theme-button-color), black 15%))'
          : 'var(--tg-theme-button-color)',
        boxShadow: canSubmit
          ? '0 4px 12px color-mix(in srgb, var(--tg-theme-button-color) 40%, transparent)'
          : 'none',
      }}
    >
      {/* Subtle shine sweep */}
      {canSubmit && (
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.15) 50%, transparent 60%)',
            animation: 'shimmer 3s ease-in-out infinite',
            backgroundSize: '200% 100%',
          }}
        />
      )}
      <span className={`relative flex items-center justify-center gap-2 ${isLoading ? 'opacity-0' : ''}`}>
        {submitMutation.isPending
          ? t('generate.submitting')
          : isGenerating
            ? t('generate.generating')
            : t('generate.submit')}
      </span>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <IconSpinner size={20} className="animate-spin" />
        </div>
      )}
    </button>
  )
}
